export const NAV_MODES = {
  NORMAL: 'normal',
  OVERLAY_OPEN: 'overlay-open',
  OVERLAY_CLOSED: 'overlay-closed',
};
